import { QuotePricingLineItem } from 'modules/finance/components/Quotes/utils'

// Recursive tree operations for quote line items and their nested phase children
export const flattenLineItems = (items: QuotePricingLineItem[]): QuotePricingLineItem[] =>
  items.flatMap((item) => [
    item,
    ...(item.financeLineItems ? flattenLineItems(item.financeLineItems) : []),
  ])

export const findItemInTree = (
  items: QuotePricingLineItem[],
  id: number
): QuotePricingLineItem | null => {
  for (const item of items) {
    if (item.id === id) return item
    const inChild = item.financeLineItems
      ? findItemInTree(item.financeLineItems, id)
      : null
    if (inChild) return inChild
  }
  return null
}

export const replaceItemInTree = (
  items: QuotePricingLineItem[],
  itemId: number,
  newItem: QuotePricingLineItem
): QuotePricingLineItem[] =>
  items.map((item) => {
    if (item.id === itemId) return newItem
    return {
      ...item,
      financeLineItems: item.financeLineItems
        ? replaceItemInTree(item.financeLineItems, itemId, newItem)
        : undefined,
    }
  })

export const removeItemFromTree = (
  items: QuotePricingLineItem[],
  itemId: number
): QuotePricingLineItem[] =>
  items
    .filter((item) => item.id !== itemId)
    .map((item) => ({
      ...item,
      financeLineItems: item.financeLineItems
        ? removeItemFromTree(item.financeLineItems, itemId)
        : undefined,
    }))

export const addItemToPhaseInTree = (
  items: QuotePricingLineItem[],
  phaseId: number,
  newItem: QuotePricingLineItem
): QuotePricingLineItem[] =>
  items.map((item) => {
    if (item.id === phaseId) {
      return {
        ...item,
        financeLineItems: [...(item.financeLineItems ?? []), newItem],
      }
    }
    return item
  })
